import {
  Breakpoints,
  getMaxWidthMediaQuery,
  getMinWidthMediaQuery,
} from "@acin.reactjs/acin-ui/theme";

export const AppBreakpoints: Breakpoints = {
  xs: 479,
  sm: 767,
  md: 959,
  lg: 1280,
  xl: 1600,
};

export const AppMediaQueries = {
  maxMobile: getMaxWidthMediaQuery(AppBreakpoints.sm),
  minTablet: getMinWidthMediaQuery(AppBreakpoints.sm + 1),
  maxTablet: getMaxWidthMediaQuery(AppBreakpoints.md),
  minDesktop: getMinWidthMediaQuery(AppBreakpoints.md + 1),
  maxDesktop: getMaxWidthMediaQuery(AppBreakpoints.lg),
};
